import { useCallback } from "react";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useCollapseContext } from "../Utils/Collapse";
import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";

const OptionDescriptionButton = ({ className }) => {
  const { collapseId, isExpanded, setIsExpanded } = useCollapseContext();

  const t = useFormatMessage();
  const showDescriptionLabel = t(intlMessages.showDescription);

  const handleClicked = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded, setIsExpanded]);

  const buttonClassName = classNames("btn btn-link padding-x-xs", className);

  return (
    <Button
      type="button"
      className={buttonClassName}
      iconClassName="fas fa-question-circle text-muted"
      onClick={handleClicked}
      aria-controls={collapseId}
      aria-expanded={isExpanded}
      aria-label={showDescriptionLabel}
    />
  );
};

export default OptionDescriptionButton;

const intlMessages = defineMessages({
  showDescription: {
    id: "inputs.optionDescriptionButton.showDescription",
    defaultMessage: "Cliquer pour voir plus d'info"
  }
});
